// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PasswordRequirementsBlock-module-infoBlock-2chrJ{margin-top:24px;display:grid;grid-gap:4px;gap:4px}.PasswordRequirementsBlock-module-iconClassName-CyH7C{height:auto;margin-bottom:8px}.PasswordRequirementsBlock-module-requirementDescription-2iUHn{line-height:14px}", ""]);
// Exports
exports.locals = {
	"infoBlock": "PasswordRequirementsBlock-module-infoBlock-2chrJ",
	"iconClassName": "PasswordRequirementsBlock-module-iconClassName-CyH7C",
	"requirementDescription": "PasswordRequirementsBlock-module-requirementDescription-2iUHn"
};
module.exports = exports;
